function Searchbar() {
  return (
      <header className="bg-[#282c34] min-w-screen text-white ">
        <a href="/">
            je remplis plus tard tkt
        </a>
      </header>
  );
}

export default Searchbar;